module.exports = __webpack_public_path__ + "img/Grappe_1.asset.94bfc1ba.svg";